import React from 'react';

interface LandingProps {
  onStart: () => void;
}

const Landing: React.FC<LandingProps> = ({ onStart }) => {
  return (
    <div className="p-10 md:p-16 text-center relative overflow-hidden">
      {/* Background Glows */}
      <div className="absolute -top-24 -left-24 w-64 h-64 bg-primary/20 blur-[100px] rounded-full pointer-events-none"></div>
      <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-primary/10 blur-[100px] rounded-full pointer-events-none"></div>

      <div className="relative z-10">
        <div className="mb-10 flex justify-center">
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-primary to-transparent rounded-full shadow-[0_0_15px_rgba(130,109,236,0.8)]"></div>
        </div>
        
        <h1 className="text-4xl md:text-6xl font-[900] text-white mb-8 leading-[1.1] tracking-tight uppercase italic">
          BOOST YOUR <br />
          <span className="text-primary glow-text">FINTECH BUSINESS</span>
        </h1>
        
        <div className="max-w-md mx-auto mb-12">
          <div className="bg-white/5 border border-white/10 p-4 rounded-xl mb-6 backdrop-blur-md">
             <p className="text-sm md:text-base text-gray-300 font-semibold tracking-wide uppercase">
               Discover your growth potential in the event fintech ecosystem
             </p>
          </div>
          <p className="text-lg text-gray-400 leading-relaxed font-medium">
            Get a free benchmarking report in seconds. Audit your strategic maturity and unlock the path to maximum ROI.
          </p>
        </div>

        <div className="flex flex-col items-center gap-6">
          <button
            onClick={onStart}
            className="glow-btn bg-primary hover:bg-opacity-90 text-white font-[900] py-6 px-16 rounded-full text-2xl uppercase italic tracking-widest transition-all transform hover:-translate-y-1 active:scale-95"
          >
            Start Now
          </button>
          
          <div className="flex items-center gap-3 text-[10px] text-gray-500 font-black tracking-[0.3em] uppercase">
            <span className="w-8 h-[1px] bg-gray-800"></span>
            3-Minute Strategic Scan
            <span className="w-8 h-[1px] bg-gray-800"></span>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-3 gap-4 border-t border-white/5 pt-10">
          <div className="text-center">
            <div className="text-primary font-black text-xl mb-1">Maturity</div>
            <div className="text-[10px] text-gray-500 uppercase font-bold">Scoring</div>
          </div>
          <div className="text-center">
            <div className="text-primary font-black text-xl mb-1">Radar</div>
            <div className="text-[10px] text-gray-500 uppercase font-bold">Visualization</div>
          </div>
          <div className="text-center">
            <div className="text-primary font-black text-xl mb-1">ROI</div>
            <div className="text-[10px] text-gray-500 uppercase font-bold">Insights</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;